import React from "react";
import { useParams, generatePath, Navigate } from "react-router-dom";
import { RouterType } from "@type/index";

const RedirectTop = () => {
  const params = useParams();
  const url = generatePath(
    "/:region/:language/stylingbook/officialstyling/women",
    {
      ...params
    } as RouterType
  );

  return <Navigate replace to={url} />;
};
export default RedirectTop;
